import React, { useRef, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

const ResizeSensor = ({ onResize = () => {} }) => {
    const iframeRef = useRef();

    const handleResize = useCallback(() => {
        window.requestAnimationFrame(() => {
            const iframe = iframeRef.current;
            if (!iframe) return;

            const { clientHeight, clientWidth } = iframe;
            onResize({ height: clientHeight, width: clientWidth });
        });
    }, [onResize]);

    useEffect(() => {
        const iframe = iframeRef.current;
        if (!iframe) return;

        const { clientHeight, clientWidth, contentWindow } = iframe;

        contentWindow?.addEventListener('resize', handleResize);

        // Send the first resize event upon mount
        onResize({ height: clientHeight, width: clientWidth });

        return () => contentWindow?.removeEventListener('resize', handleResize);
    }, [handleResize, onResize]);

    return (
        <iframe
            ref={iframeRef}
            style={{
                height: '100%',
                width: '100%',
                border: 'none',
                background: 'transparent',
                position: 'absolute',
                zIndex: -1,
                top: 0,
                left: 0,
            }}
        />
    );
};

ResizeSensor.propTypes = {
    onResize: PropTypes.func,
};

export default ResizeSensor;
